export const BASE_URL = "/api/sfa/v1/merchandising-configurations";
export const TERRITORY_URL = "/api/sfa/v1/territory";

export function isApiSuccess(resp) {
  return (
    resp &&
    (resp.code === 200 ||
      resp.code === 201 ||
      resp.status === "success" ||
      resp.status === "OK")
  );
}

export function hasAllowedAction(row, action) {
  return (
    row &&
    Array.isArray(row.allowed_actions) &&
    row.allowed_actions.includes(action)
  );
}

export function formatTerritoryLabel({ code, name }) {
  return `${code || ""} ${name || ""}`.trim();
}

export function emptyItemRow(sequence = 1) {
  return {
    id: null,
    label: "",
    sequence,
    valid_from: null,
    valid_to: null,
  };
}
